<!-- Error Dialog here -->
<p-dialog  [ngClass]="{'gs-error-dialog-archive':this.isArchive}"
[id]="dialogId"  [closable]="closable" draggable="false" [modal]="true" (onHide)="hideDialog()" [(visible)]="isShowDialog"
          styleClass="gs-error-dialog" [style]="{ width: '420px', 'max-height': '680px' }">
    <ng-template pTemplate="header">
        <div class="flex items-center gap-2">
            <svg-icon svgClass="icon-18" src="/assets/icons/exclamation.svg"></svg-icon>
            <span class="font-600 text-18 white-space-nowrap pl-2">
                   {{ dialogHeader }}
                </span>
        </div>
    </ng-template>
    <div class="flex flex-col p-6 mx-[5px]">
        <p class="text-16 font-600 mb-4">{{ title }}</p>
        @if(content){<p class="my-1 mb-3 gs-text-black">{{ content }}</p>}
        @if (comment) {
            <textarea
                    class="card-textarea"
                    rows="5"
                    cols="30"
                    pTextarea
                    placeholder="Write a comment"
                    [(ngModel)]="commentText"
            >
              </textarea>
        }
        <div class="flex flex-row justify-center items-center w-full pt-3 gap-x-5">
            @if(cancelBttnText){<button pButton [outlined]="true" severity="secondary" (click)="closeDialog()" class="w-[50%] h-[38px] font-700 text-gray-900 text-14" [label]="cancelBttnText"></button>}
            <button [loading]="loading" pButton severity="secondary" [style]="{'padding':'8px'}" (click)="confirmDialog()" class="w-[50%] h-[38px] border-2 text-14 font-700" [label]="btnName"></button>
        </div>
    </div>
</p-dialog>